<template>
  <div>
    <canvas
      ref="canvas"
      width="800"
      :height="height"
      style="display: none;"
    />
    <div ref="code">
      <table class="embed">
        <tr>
          <td>
            <a
              class="embed"
              :href="link"
            >
              <img
                ref="image"
                :src="s3_url"
                style="width: 400px; height: 393px;"
                width="400"
                height="393"
              >
            </a>
          </td>
        </tr>
      </table>
      <br>
      <a class="click_link" :href="link">Click <u>HERE</u> to view edit.</a>
    </div>
  </div>
</template>

<script>
/*
The `EmbedCode` component prints the code that
1) The user see in the modal
2) The code that is copied to the clipboard

Important: Since we are copying the styles we need to use inline styles and tables
*/
import api from '@/_api';

export default {
  name: 'EmbedCode',
  props: {
    title: {
      type: String,
      default: '',
    },
    hero: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      width: 800,
      height: 650 + 84,
      footerh: 84,
      img_h: 650,
      data_url: null,
      s3_url: null,
    };
  },
  mounted() {
    this.$emit('open');
    this.generateImage();
  },
  methods: {
    generateImage() {
      // eslint-disable-next-line
    CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, r) {
      // eslint-disable-next-line
      if (w < 2 * r) r = w / 2;
        // eslint-disable-next-line
      if (h < 2 * r) r = h / 2;
        this.beginPath();
        this.moveTo(x + r, y);
        this.arcTo(x + w, y, x + w, y + h, r);
        this.arcTo(x + w, y + h, x, y + h, r);
        this.arcTo(x, y + h, x, y, r);
        this.arcTo(x, y, x + w, y, r);
        this.closePath();
        return this;
      };
      const ttl = this.title.striphtml();

      const realH = this.img_h + (ttl.length === 0 ? 0 : this.footerh);
      const myCanvas = this.$refs.canvas;
      const ctx = myCanvas.getContext('2d');
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      ctx.globalAlpha = 0.0;
      ctx.clearRect(0, 0, this.width, realH);
      ctx.globalAlpha = 1.0;
      ctx.fillStyle = '#FFFFFF';
      ctx.roundRect(0, 0, this.width, realH, 16);
      ctx.clip();
      img.onload = () => {
        console.log('Image loaded');
        ctx.drawImage(img, 0, 0, this.width, this.img_h); // Or at whatever offset you like
        ctx.lineWidth = 4;
        ctx.strokeStyle = '#D4D4D4';
        ctx.roundRect(0, 0, this.width, realH, 16);
        ctx.stroke();
        ctx.fillStyle = '#333333';
        if (ttl.length > 0) {
          ctx.fillRect(0, this.height - this.footerh, this.width, this.footerh);
          ctx.font = '50px serif';
          ctx.fillStyle = '#FFFFFF';
          ctx.font = '24px Arial';
          ctx.fillText(this.title.striphtml(), 32, this.height - 34);
        }
        this.data_url = this.$refs.canvas.toDataURL('image/png');
        this.upload_s3();
      };
      img.src = this.hero;
    },
    html() {
      return this.$refs.code.innerHTML;
    },
    upload_s3() {
      api.post('/upload_media_to_s3', {
        url: this.data_url,
      }).then((response) => {
        this.s3_url = response.data.upload_url;
        // this.$emit('ready');
        // console.log('S3 Image loaded');
        this.$refs.image.onload = () => {
          this.$emit('ready');
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.click_link {
  text-decoration: none;
  font-family: 'SilkaLight';
  position: relative;
  font-weight: bold;
  top: 26px;
}
.embed {
  background: #fff;
}
</style>
